module.exports = __webpack_public_path__ + "media/src/images/mails/gray-bf23adb14f26dba74e4604aa61e8e4f9.png";